import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  return (
    <div >
      <section className=" about-section pt-16 pb-8 pl-8 pr-8 lg:pt-24 lg:pb-12 lg:pl-12 lg:pr-12 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 mt-4">
        {/* Titolo */}
        <h1 className="text-4xl mb-8">{t('about.title')}</h1>

        {/* Layout immagine e testo */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

          {/* Testo */}
          <div>
            <p className="mb-8 sm:text-sm md:text-lg lg:text-xl">{t('about.content.intro')}</p>
            <p className="mb-8 sm:text-sm md:text-lg lg:text-xl">{t('about.content.history')}</p>
            <p className=" sm:text-sm md:text-lg lg:text-xl">{t('about.content.experience')}</p>
          </div>

          <div className="flex justify-center">
            <img
              src="./images/lorenzo.jpeg"
              alt="Descrizione"
              className="w-full max-w-md rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
